import axios from 'axios';
import { useState, useEffect } from 'react';
import {
  Typography,
  Modal,
  Fade,
  Backdrop,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Stack
} from '@material-ui/core';
import PropTypes from 'prop-types';
import RoleTable from '../RoleTable';
import AssignRoleToUserDialog from './AssignRoleToUserDialog';
import { getIDToken } from '../../authentication/login/amplify';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  p: 4
};

UserDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  user: PropTypes.string
};

export default function UserDetailsModal({ isOpen, closeHandler, user }) {
  const [roleDialogOpen, setRoleDialogOpen] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    // initial call to get role list when user is updated
    fetchUsersRoles();
    // eslint-disable-next-line
  }, [user]);

  const fetchUsersRoles = async () => {
    const jwt = await getIDToken();
    if (jwt && user !== '') {
      axios
        .get(`${process.env.REACT_APP_API}/admin/users/${user}/roles`, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })
        .then((response) => {
          setRoles(response.data);
          return response.data;
        })
        .catch((error) => {
          console.error('failed to get list of roles ', error.message);
        });
    }
  };

  const handleRoleCloseDialog = () => {
    setRoleDialogOpen(false);
  };
  const handleRoleOpenDialog = () => {
    setRoleDialogOpen(true);
  };

  return (
    <>
      <AssignRoleToUserDialog
        isOpen={roleDialogOpen}
        updateRoles={fetchUsersRoles}
        closeHandler={handleRoleCloseDialog}
        user={user}
      />
      <Modal
        open={isOpen}
        sx={{ outline: 'none' }}
        onClose={closeHandler}
        aria-labelledby="user-details-modal"
        aria-describedby="modal to display user details"
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={isOpen}>
          <Grid direction="row" sx={style} container>
            <Grid item xs={12} md={1} lg={3} onClick={closeHandler} />
            <Grid item xs={12} md={10} lg={6}>
              <Card>
                <CardHeader sx={{ padding: 2 }} title={`${user} Details`} />
                <Divider />
                <CardContent sx={{ paddingTop: 1 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ paddingTop: 2 }}
                  >
                    <Typography variant="h6">Roles</Typography>
                    <Button onClick={handleRoleOpenDialog} variant="contained">
                      Add Role
                    </Button>
                  </Stack>
                  <RoleTable user={user} updateRoles={fetchUsersRoles} roles={roles} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} med={1} lg={3} onClick={closeHandler} />
          </Grid>
        </Fade>
      </Modal>
    </>
  );
}
